// A quote must carry either VAT or a documentation fee so neither is forgotten when it is
// generated. Orders are exempt when every item comes from one of these stores -- they are the
// low-value/no-paperwork sources that never attract VAT or need customs documentation.
// Mirrors Admin::OrderService::VAT_DOCUMENTATION_EXEMPT_STORES; keep the two in step.
export const VAT_DOCUMENTATION_EXEMPT_STORES: readonly string[] = ['Tini Express', 'SHEIN', 'Temu'];

export const isVatDocumentationExemptStore = (storeName?: string | null): boolean =>
  !!storeName && VAT_DOCUMENTATION_EXEMPT_STORES.includes(storeName);

// In scope when at least one item comes from a non-exempt store; a mixed order (say a Puma
// item alongside a SHEIN one) still needs VAT or documentation for the Puma item's sake.
//
// An item whose store isn't in the loaded list is treated as exempt so a slow or failed
// /stores response can't block an otherwise valid save — the backend check is authoritative.
export const requiresVatOrDocumentationFee = (
  items: { store_id?: number }[],
  stores: { label: string; value: number }[],
): boolean =>
  items.some((item) => {
    const store = stores.find((s) => s.value === Number(item.store_id));
    return store ? !isVatDocumentationExemptStore(store.label) : false;
  });
